<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import { usePermissions } from '@/composables/usePermissions';

export default {
  page: {
    title: "Role",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
        role:localStorage.getItem('role'),
      title: "User List/Roles",
      items: [
        {
          text: "User",
          href: "/",
        },
        {
          text: "List/Roles",
          active: true,
        },
      ],

        country_:'',
        mine:'',
        country:[],
        IDUser_:'',

        Mainmenu:[],
        SubMenu:[],
        
        ListUser:[],
        
        DetailUser:[],
        AllMenu:[],
        MyMainMenu:[],

        //loading
        loadingDetail:false,
        loadingRoles:true,
        //end of loading

        ButtonSeen:true,

        //form
            URLRider:'', //mis
            typeUser:'',
            fullname:'',
            email:'',
            phonenumber:'',
            password:'',
            confirm_password:'',
        //
        user_id: '',
    };

    
  },
    setup() {
        const {
            canReadInternalUser,
            permissions,
            canUpdateInternalUser,
            canCreateInternalUser
        } = usePermissions()
        return {
            canReadInternalUser,
            permissions,
            canUpdateInternalUser,
            canCreateInternalUser
        };
    },
  methods: {

    downloadExcel: function () {
        location.href= process.env.VUE_APP_API_BASEURL+'users/export';
    },

    myProfile(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'user/my')
        .then(response => {
            if (response) {
                this.mine = response.data;
                // console.log(this.mine);
                // console.log(this.mine.country_id);
            } else {
                // console.log('daddddd');
                this.messageBag = ['No record.'];
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },

    GetCountry(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'country')
        .then(response => {
        // console.log('xxxxxxx');
            if (response) {
                if(response.data.status=='error'){
                    // console.log('aaaaaaaaaa');
                    this.messageBag = response.data.msj;
                    this.countreload = true;
                }else{
                    // console.log(response.data);
                    this.country = response.data;
                    this.countreload = true;
                    
                }
                
            } else {
                // console.log('daddddd');
                this.messageBag = ['No record.'];
                this.countreload = true;
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
                this.countreload = true;
        });
    },

    getListUser(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'user/list')
        .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.ListUser = response.data;
                console.log("Listtt",this.ListUser);
                // console.log('xxxx');
            } else {
                // console.log('daddddd');
                this.messageBag = ['No record.'];
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },
    GetDetailUser(IDUser){
        this.ButtonSeen=true;
        this.loadingDetail=true;
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'user/'+IDUser)
        .then(response => {
            if (response) {
                // console.log('asdadsa');
                // console.log(response.data);
                this.DetailUser = response.data;
                this.loadingDetail=false;
            } else {
                this.messageBag = ['No record.'];
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
        
    },
    EditMenu(IDUser){
        this.ButtonSeen=true;
        this.loadingDetail=true;
        
        this.IDUser_ = IDUser;
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'menu/all')
        .then(response => {
            if (response) { 
                this.AllMenu = response.data;


                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.get(process.env.VUE_APP_API_BASEURL+'menu/mainmenu/'+IDUser)
                .then(response => {
                    this.MyMainMenu = response.data;
                    // console.log(this.MyMainMenu);
                    this.loadingDetail=false;
                });

              
                
            } else {
                this.messageBag = ['No record.'];
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },

    DeleteUser(uid){
        this.user_id = uid;
    },

    ChangeRoles(e){

        this.ButtonSeen=true;

        e.preventDefault()

        // const posting_ = { 
        //     Mainmenu: this.Mainmenu,
        //     SubMenu: this.SubMenu,
        // };
        // this.namesf.filter(iteme => iteme.checked).map(namea => namea.namea)

        // console.log(this.MyMainMenu.filter(item_ => item_.IsSelect).map(id => id.id));
        this.Submenu = [];

        for (let i = 0; i < this.MyMainMenu.length; i++) {
            if (this.MyMainMenu[i].manu) {
                this.Submenu = this.Submenu.concat(this.MyMainMenu[i].manu.filter(item21 => item21.isSubMenu).map(submenu => submenu.id));
            }
        }

        const posting_ = { 
            menu: this.MyMainMenu.filter(item_ => item_.IsSelect).map(id => id.id),
            submenu: this.Submenu,
        };

        console.log('********');
        console.log(posting_);
        console.log('********');

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'menu/assign/'+this.IDUser_, posting_)
        .then(response => {
            if (response) {
                console.log(response.data);
                this.ButtonSeen=false;
            }else{
                this.ButtonSeen=false;
                console.log('tak ok');
            }
        });

    },

    confirmDeleteUser(e){
        e.preventDefault()
        
        const posting_ = {                
            user_id: this.user_id,
        };

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'user/delete_user', posting_)
        .then(response => {
            if (response) {
                alert(response.data.msj); 
                //this.$router.push({ name: 'UserRole' });
                this.$router.go(this.$router.currentRoute);                      
            }
            else{
                console.log('ada problem');
            }
        });
    },

    AddNewUser(e)
    { 
        if(this.confirm_password == this.password){
            e.preventDefault()

            const posting_ = { 
                name: this.fullname,
                email: this.email,
                password: this.password,
                country: this.country_,
                phonenumber: this.phonenumber,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'user/create', posting_)
            .then(response => {
                if (response) {
                    document.getElementById("AddNewUser").reset();
                    alert(response.data.msj);
                    // console.log(response);
                    //this.getListUser();
                    this.$router.go(this.$router.currentRoute);
                }else{
                    this.ButtonSeen=false;
                    console.log('tak ok');
                }
            });
        }else{
            e.preventDefault()
            alert('Password Not Match!')
        }

    },
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
  },

    mounted() {
        if(this.role != 3){
            this.getListUser();
        }else{
            alert('You are not authorized to view the requested page!')
        }
        this.myProfile();
        this.GetCountry();
    },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-end mb-3">
    <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModalgrid"  v-if="canCreateInternalUser"><i class="ri-add-line align-middle me-1"></i> Add New User</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <!--button @click="downloadExcel()" class="btn btn-success"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br-->
    </div>
        <div class="card">
            <div class="card-body" v-if="canReadInternalUser">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                    <DataTable class="table table-striped table-nowrap mb-0"> 
                                     <thead class="table-secondary">
                                            <tr>
                                                <th>No.</th>
                                                <th scope="col">Name.</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Phone Number</th>
                                                <th scope="col">Role</th>
                                                <th scope="col">Role Id</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="(item, index) in ListUser" :key="index" class="content">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.email }}</td>
                                                <td>{{ item.phone_no }}</td>
                                                <td>{{ item.role_name }}</td>
                                                <td>{{ item.role_id }}</td>
                                                <td>
                                                    <i v-if="canUpdateInternalUser" @click="GetDetailUser(item.id)" class="ri-eye-fill" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg"></i>
                                                    &nbsp;
                                                    <i v-if="canUpdateInternalUser" @click="DeleteUser(item.id)" class="ri-delete-bin-5-fill" data-bs-toggle="modal" data-bs-target=".deleteUser"></i>
                                                    <!--i @click="EditMenu(item.id)" class="bx bx-wrench" data-bs-toggle="modal" data-bs-target=".editRole"></i-->
                                                </td>
                                            </tr>
                                        </tbody>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="text-center text-muted p-4">
            You do not have permission to view Users.
            </div>
        </div>


        <!-- modal -->
            <div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="myLargeModalLabel">Profile Detail</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div v-if='loadingDetail'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <p class="text-muted mb-0">
                                                Name
                                            </p>
                                            <h6 class="mb-0">
                                                {{ DetailUser.name }}
                                            </h6>
                                        </div>

                                        <div class="col-lg-6">
                                            <p class="text-muted mb-0">
                                                Email:
                                            </p>
                                            <h6 class="mb-0">
                                                {{ DetailUser.email }}
                                            </h6>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <p class="text-muted mb-0">
                                                Role:
                                            </p>
                                            <h6 class="mb-0">
                                                {{ DetailUser.role }}
                                            </h6>
                                        </div>
                                        <br><br><br>
                                        <div class="col-lg-6">
                                            <p class="text-muted mb-0">
                                                Country:
                                            </p>
                                            <h6 class="mb-0">
                                                {{ DetailUser.country }}
                                            </h6>
                                        </div>
                                        <br><br><br>
                                        <div class="col-lg-12">
                                            <h6 class="mb-0">
                                                List Of Menu
                                            </h6>
                                            <hr>
                                        </div>
                                        <div class="col-lg-6" v-for="(item_, index) in DetailUser.ListMenu" :key="index">
                                            <ul class="list-group">
                                                <li class="list-group-item active">{{ item_.name }}</li>
                                                <li class="list-group-item" v-for="(item2, index2) in item_.submenu" :key="index2">
                                                    <i class="ri-bill-line align-middle me-2"></i> {{ item2.name }}
                                                </li>
                                            </ul>
                                            <br>
                                        </div>
                                
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>



            <div class="modal fade bs-example-modal-lg editRole" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="myLargeModalLabel">Profile Edit Menu</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div v-if='loadingDetail'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="card-body">
                                    <form @submit="ChangeRoles">
                                        <div class="row">
                                            <div class="col-lg-12" v-for="(item_, index) in MyMainMenu" :key="index">
                                                <ul class="list-group">
                                                    
                                                    <li class="list-group-item">
                                                        <div class="form-switch">
                                                            <input class="form-check-input" v-model="item_.IsSelect" :id="item_.id" type="checkbox" role="switch" checked> 
                                                            {{ item_.name }}
                                                        </div>                                                        
                                                    </li> <!-- main menu -->
                
                                                    <li class="list-group-item " v-for="(item2, index2) in item_.manu" :key="index2"> <!-- submenu -->
                                                        <div class="form-switch">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            <input class="form-check-input" v-model="item2.isSubMenu" :id="item2.id"  type="checkbox" role="switch" > 
                                                            {{ item2.name }}
                                                        </div>

                                                    </li>
                                                </ul>
                                                <br>
                                                
                                            </div>
                                        </div>
                                        <div v-if="ButtonSeen">
                                            <button type="submit" class="btn btn-primary">Update Menu</button>
                                        </div>
                                        <div v-else>
                                            <br>
                                            <div class="alert alert-success alert-dismissible fade show" role="alert">
                                                <strong>Edit Menu Success</strong> 
                                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                            </div>
                                        </div>
                                        <!-- <input type="sub" -->
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            
            <div class="modal fade" id="exampleModalgrid" tabindex="-1" aria-labelledby="exampleModalgridLabel">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalgridLabel">Add New User</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <form @submit="AddNewUser" id="AddNewUser">
                                <div class="row g-3">
                                    <div class="col-xxl-12">
                                        <div>
                                            <label for="firstName" class="form-label">Full Name <span class="text-danger">*</span></label>
                                            <input type="text" v-model='fullname' class="form-control" id="firstName" placeholder="Enter Full Name" required/>
                                        </div>
                                    </div>
                                    <!--end col-->
                        
                                    <!--end col-->
                                    <div class="col-lg-12" v-if="mine.country_id == NULL">
                                        <label class="form-label">Country<span class="text-danger">*</span></label>
                                        <div>
                                            <select v-model="country_" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country">
                                                <!--option value="" >Admin to all country</option-->
                                                <option v-for="(item, index) in country" :key="index" :value="item.id" >
                                                    {{ item.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    
                                    <!--end col-->
                                    <div class="col-xxl-12">
                                        <label for="emailInput" class="form-label">Email <span class="text-danger">*</span></label>
                                        <input type="email" class="form-control" id="emailInput" v-model='email' placeholder="Enter email" required/>
                                    </div>
                                    <div class="col-xxl-12">
                                        <label for="phoneInput" class="form-label">Phone Number <span class="text-danger">*</span></label>
                                        <input type="test" class="form-control" id="phoneInput" v-model='phonenumber' placeholder="Enter Phone Number"/>
                                    </div>
                                    <div class="col-xxl-12">
                                        <label for="passwordInput" class="form-label">Password <span class="text-danger">*</span></label>
                                        <input type="password" class="form-control" v-model='password' placeholder='**********' id="passwordInput" required/>
                                    </div>
                                    <div class="col-xxl-12">
                                        <label for="passwordInput" class="form-label">Confirm Password <span class="text-danger">*</span></label>
                                        <input type="password" class="form-control" v-model='confirm_password' placeholder='**********' id="passwordInput" required/>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="hstack gap-2 justify-content-end">
                                            <button type="button" class="btn btn-light"
                                                data-bs-dismiss="modal">Close</button>
                                            <button type="submit" class="btn btn-primary">Submit</button>
                                        </div>
                                    </div>
                                    <!--end col-->
                                </div>
                                <!--end row-->
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade bs-example-modal-center deleteUser" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body text-center p-5">
                            <form @submit="confirmDeleteUser" id="confirmDeleteUser">
                            <div class="mt-4">
                                <h4 class="mb-3">Are you sure want to remove this user?</h4>
                                <div class="col-xxl-12">
                                    <input type="hidden" class="form-control" v-model='user_id' id="user_id"/>
                                </div>
                                <div class="hstack gap-2 justify-content-center">
                                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                                    <!--a href="javascript:void(0);" class="btn btn-danger">Remove</a-->
                                    <button type="submit" class="btn btn-danger">Remove</button>
                                </div>
                            </div>
                            </form>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
        <!-- end of modal -->

    </Layout>
</template>